import {resolveGenericContentCta, type GenericContent} from '../../../../../../brand/lib/types/contentful'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Heading, Text} from '@primer/react-brand/esm'
import {CtaButtons} from '../../_shared/CtaButtons/CtaButtons'
import {Eyebrow} from '../../_shared/Eyebrow/Eyebrow'
import {Spacer} from '../../_shared/Spacer/Spacer'
import {ShareButton} from '../../_shared/ShareButton/ShareButton'
import {Mascot} from '../../_shared/Mascot/Mascot'

import Styles from './Hero.module.css'

type Props = {
  content: GenericContent
  location: string
  nestedContent: GenericContent[]
  sectionId?: string
  sectionIndex: number
}

export function Hero(props: Props) {
  const {content, location, nestedContent, sectionId, sectionIndex} = props
  const {heading, subheading, label, text} = content.fields

  const title = heading
  const subTitle = subheading ? documentToPlainTextString(subheading) : ''

  const eyebrow = label?.fields.text
  const description = text ? documentToPlainTextString(text) : ''
  const ctaGroup = resolveGenericContentCta(content, {legacyFallback: 'first'})

  const mascot = nestedContent.at(0)?.fields.id || ''

  const hideEyebrowIcon = sectionIndex === 0

  return (
    <div className={Styles.Hero}>
      <div className={Styles.Cell}>
        {subTitle && <Eyebrow className={Styles.SubTitle} text={subTitle} hideIcon />}
        {eyebrow && (
          <Eyebrow className={Styles.EyebrowMobile} text={eyebrow} hideIcon={hideEyebrowIcon} aria-hidden="true" />
        )}

        {title && (
          <Heading
            className={Styles.Title}
            data-heading={1}
            as={sectionIndex === 0 ? 'h1' : 'h2'}
            {...(mascot && {'data-has-mascot': true})}
          >
            {title}
          </Heading>
        )}

        {sectionId && sectionIndex > 0 && <ShareButton id={sectionId} location={location} />}
      </div>

      <div className={Styles.Cell}>
        {eyebrow && <Eyebrow className={Styles.EyebrowDesktop} text={eyebrow} hideIcon={hideEyebrowIcon} />}

        <div>
          {description && (
            <div>
              <Text as="p" className={Styles.Description}>
                {description}
              </Text>
            </div>
          )}

          {ctaGroup && (
            <>
              <Spacer size="64px" />
              <div>
                <CtaButtons contentfulContent={ctaGroup} location={location} />
              </div>
            </>
          )}
        </div>

        {/* Mascot */}
        {/* Hide on Desktop when there are no CTAs, since the description might touch the mascot. */}
        {mascot && <Mascot mascot={mascot} hideOnDesktop={!ctaGroup} />}
      </div>
    </div>
  )
}
